import request from '@/utils/request'

/**
 * 商品台账分页（库存历史）
 * @param {*} data - { skuCode, sourceBillTypeList, changeTimeStart, changeTimeEnd, page, size, sortBy }
 *   sourceBillTypeList: 单据类型枚举数组，支持多选
 * @returns
 */
export function getGoodsLedgerPage(data) {
  return request({
    url: '/mg/daohang-stock-api/kcStorageFtp/skuLedgerPage',
    method: 'post',
    data,
  })
}


/**
 * 获取快速添加商品列表
 * @param {*} data
 * @returns
 */
export function getFastAddGoodsList(data) {
  return request({
    url: `/mg/daohang-product-api/goodsCache/listFast`,
    method: 'post',
    data,
  })
}

// 商品台账导出
export function exportExcel(data) {
  return request({
    url: '/mg/daohang-stock-api/kcStorageFtp/skuLedger/exportExcel',
    method: 'post',
    responseType: 'blob',
    data,
  })
}

// 商品台账合计
export function sumGoodsLedger(data) {
  return request({
    url: '/mg/daohang-stock-api/kcStorageFtp/skuLedgerSum',
    method: 'post',
    data,
  })
}


